import React from "react";
import { useOutletContext } from "react-router-dom";
import { ClientFeedView } from "@/domains/Client/components/ClientFeedView";

interface ApprovalOutletContext {
  clientId: string;
  token?: string;
}

export const ClientFeedRoute: React.FC = () => {
  const { clientId, token } = useOutletContext<ApprovalOutletContext>();

  return <ClientFeedView clientId={clientId} token={token} />;
};
